import { useMemo, useState } from "react";
import { Common } from "@lainco/react-toolbox";
import styled from "styled-components";
import { useItems } from "../../app/browsersSlice";
import { groupBy, sum } from "lodash";
import { Balance } from "./Balance";
import Amount from "../Amount";
import MultiplesBankAccountBalancesModal from "../../modals/MultiplesBankAccountBalancesModalContent";
import { stringIsNullOrSpaces } from "@lainco/react-toolbox/dist/lib/utils";
import { usePost, useServicePost } from "../../lib/services";
import BankAccountBalance from "../../model/BankAccountBalance";

export function BankBalancesTab() {
  const [items, , , refreshItems] = useItems("bankAccounts");
  const [modalAccounts, setModalAccounts] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const postBankAccountBalance = usePost("bankAccountBalances", BankAccountBalance);
  const updateMercuryBalances = useServicePost("mercuryBalancesUpdate");

  console.log({ items, bank: items?.[0]?.bank, company: items?.[0]?.company });

  const fx = 1450;

  const openModalFor = (bank, company) => {
    console.log("Opening modal for", { bank, company });
    setSelectedBank(bank);
    setSelectedCompany(company);
    setIsOpen(true);
  };

  const accounts = useMemo(() => {
    if (items === null) return null;
    const g = Object.entries(groupBy(items, (x) => x.company?.name)).map(([companyName, accounts]) => ({
      name: companyName,
      company: accounts[0].company,
      banks: Object.entries(groupBy(accounts, (x) => x.bank?.name)).map(([bankName, bankAccounts]) => ({
        name: bankName,
        bank: bankAccounts[0].bank,
        accounts: bankAccounts.map((a) => ({
          model: a,
          ...a,
          currentBalance: {
            ...a.getCurrentBalance(),
            displayName: a.getDisplayName(),
            currency: a.currency.code,
            fx,
            eqUsd: a.currency.code === "ARS" ? a.getCurrentBalance().balance / fx : a.getCurrentBalance().balance,
          },
        })),
      })),
    }));
    console.log({ grouped: g });
    // Armo los saldos
    for (const company of g) {
      for (const bank of company.banks) {
        bank.balance = sum(bank.accounts.map((x) => x.currentBalance.eqUsd));
      }
      company.balance = sum(company.banks.map((x) => x.balance));
    }
    const r = { balance: sum(g.map((x) => x.balance)), companies: g };
    return r;
  }, [items]);

  if (accounts === null) return <div style={{ padding: "1em", height: "calc(100vh - 8em)" }}>Loading...</div>;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0", padding: "1em 0em", height: "calc(100vh - 8em)", overflowY: "auto" }}>
      <MultiplesBankAccountBalancesModal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        bank={selectedBank}
        company={selectedCompany}
        model={modalAccounts}
        onChange={setModalAccounts}
        onAccept={async (accounts) => {
          for (const acc of accounts)
            if (!stringIsNullOrSpaces(acc.balance)) {
              postBankAccountBalance(
                new BankAccountBalance({
                  account: acc.account,
                  balance: acc.balance,
                  date: new Date().toISOString().substring(0, 10),
                  isAutomatic: false,
                }),
                () => {
                  setIsOpen(false);
                  refreshItems();
                }
              );
            }
        }}
      />
      <TotalBalance balance={accounts.balance} />
      {accounts.companies.map((company) => (
        <Section
          key={company.id}
          value={company}
          level={2}
          getItems={(c) => c.banks}
          renderChildren={(bank) => (
            <Section
              key={bank.id}
              value={bank}
              links={[
                { name: "Edit", action: () => openModalFor(bank, company) },
                bank.bank.apiKeys?.length >= 1
                  ? {
                      name: "Update",
                      action: () => updateMercuryBalances({}, () => refreshItems()),
                    }
                  : null,
              ].filter((x) => x != null)}
              level={3}
              getItems={(b) => b.accounts}
              renderChildren={(account) => <Balance account={account} showTitle />}
            />
          )}
        />
      ))}
    </div>
  );
}

const TotalBalance = ({ balance }) => (
  <TitleContainer level={1}>
    <Title level={1}>Total</Title>
    <Number level={1}>
      <Amount currency={{ code: "USD", symbol: "u$s" }} amount={balance} precision={0} showZero />
    </Number>
  </TitleContainer>
);

const Section = ({ value, level, getItems, renderChildren, links }) => {
  console.log({ value });
  return (
    <>
      <TitleContainer level={level}>
        <Title level={level}>
          <>
            {value.name}
            <span>
              {links?.map((l, i) => (
                <Common.Link style={{ fontSize: "0.8em" }} onClick={l.action}>
                  {l.name}
                </Common.Link>
              ))}
            </span>
          </>
        </Title>
        <Number level={2}>
          <Amount currency={{ code: "USD", symbol: "u$s" }} amount={value.balance} precision={0} showZero />
        </Number>
      </TitleContainer>
      {getItems(value).map((child, index) => renderChildren(child))}
    </>
  );
};

const levels = {
  1: { color: "black", background: "#bbb", titleWeight: 700, numberWeight: 700 },
  2: { color: "#333", background: "#ddd", titleWeight: 600, numberWeight: 600 },
  3: { color: "#555", background: "#eee", titleWeight: 500, numberWeight: 500 },
  4: { color: "black", background: "unset", titleWeight: "unset", numberWeight: "unset" },
};

const TitleContainer = styled.div`
  display: grid;
  grid-template-columns: 17em 1fr;
  padding: 0.5em 1em;
  background-color: ${(props) => levels[props.level].background};
`;

const Title = styled.span`
  color: ${(props) => levels[props.level].color};
  font-weight: ${(props) => levels[props.level].titleWeight};
  font-variant: small-caps;
`;
const Number = styled.span`
  justify-self: right;
  align-self: center;
  font-weight: ${(props) => levels[props.level].numberWeight};
`;
